/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AboutRouteImport } from './routes/about';
import { Route as AircraftRouteImport } from './routes/aircraft';
import { Route as FlightsRouteImport } from './routes/flights';
import { Route as LogbookRouteImport } from './routes/logbook';
import { Route as SettingsRouteImport } from './routes/settings';
import { Route as AircraftIndexRouteImport } from './routes/aircraft.index';
import { Route as AircraftAircraftIdRouteImport } from './routes/aircraft.$aircraftId';
import { Route as AircraftNewRouteImport } from './routes/aircraft.new';
import { Route as FlightsIndexRouteImport } from './routes/flights.index';
import { Route as FlightsTrackIdRouteImport } from './routes/flights.$trackId';
import { Route as FlightsFetchRouteImport } from './routes/flights.fetch';
import { Route as LogbookIndexRouteImport } from './routes/logbook.index';
import { Route as LogbookChecksRouteImport } from './routes/logbook.checks';
import { Route as LogbookCurrencyRouteImport } from './routes/logbook.currency';
import { Route as LogbookExportRouteImport } from './routes/logbook.export';
import { Route as LogbookPrintRouteImport } from './routes/logbook.print';
import { Route as LogbookTotalsRouteImport } from './routes/logbook.totals';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any);
const AircraftRoute = AircraftRouteImport.update({
  id: '/aircraft',
  path: '/aircraft',
  getParentRoute: () => rootRouteImport,
} as any);
const FlightsRoute = FlightsRouteImport.update({
  id: '/flights',
  path: '/flights',
  getParentRoute: () => rootRouteImport,
} as any);
const LogbookRoute = LogbookRouteImport.update({
  id: '/logbook',
  path: '/logbook',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any);
const AircraftIndexRoute = AircraftIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AircraftRoute,
} as any);
const AircraftAircraftIdRoute = AircraftAircraftIdRouteImport.update({
  id: '/$aircraftId',
  path: '/$aircraftId',
  getParentRoute: () => AircraftRoute,
} as any);
const AircraftNewRoute = AircraftNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AircraftRoute,
} as any);
const FlightsIndexRoute = FlightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FlightsRoute,
} as any);
const FlightsTrackIdRoute = FlightsTrackIdRouteImport.update({
  id: '/$trackId',
  path: '/$trackId',
  getParentRoute: () => FlightsRoute,
} as any);
const FlightsFetchRoute = FlightsFetchRouteImport.update({
  id: '/fetch',
  path: '/fetch',
  getParentRoute: () => FlightsRoute,
} as any);
const LogbookIndexRoute = LogbookIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LogbookRoute,
} as any);
const LogbookChecksRoute = LogbookChecksRouteImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => LogbookRoute,
} as any);
const LogbookCurrencyRoute = LogbookCurrencyRouteImport.update({
  id: '/currency',
  path: '/currency',
  getParentRoute: () => LogbookRoute,
} as any);
const LogbookExportRoute = LogbookExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => LogbookRoute,
} as any);
const LogbookPrintRoute = LogbookPrintRouteImport.update({
  id: '/print',
  path: '/print',
  getParentRoute: () => LogbookRoute,
} as any);
const LogbookTotalsRoute = LogbookTotalsRouteImport.update({
  id: '/totals',
  path: '/totals',
  getParentRoute: () => LogbookRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/aircraft': typeof AircraftRouteWithChildren;
  '/flights': typeof FlightsRouteWithChildren;
  '/logbook': typeof LogbookRouteWithChildren;
  '/settings': typeof SettingsRoute;
  '/aircraft/$aircraftId': typeof AircraftAircraftIdRoute;
  '/aircraft/new': typeof AircraftNewRoute;
  '/flights/$trackId': typeof FlightsTrackIdRoute;
  '/flights/fetch': typeof FlightsFetchRoute;
  '/logbook/checks': typeof LogbookChecksRoute;
  '/logbook/currency': typeof LogbookCurrencyRoute;
  '/logbook/export': typeof LogbookExportRoute;
  '/logbook/print': typeof LogbookPrintRoute;
  '/logbook/totals': typeof LogbookTotalsRoute;
  '/aircraft/': typeof AircraftIndexRoute;
  '/flights/': typeof FlightsIndexRoute;
  '/logbook/': typeof LogbookIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/settings': typeof SettingsRoute;
  '/aircraft/$aircraftId': typeof AircraftAircraftIdRoute;
  '/aircraft/new': typeof AircraftNewRoute;
  '/flights/$trackId': typeof FlightsTrackIdRoute;
  '/flights/fetch': typeof FlightsFetchRoute;
  '/logbook/checks': typeof LogbookChecksRoute;
  '/logbook/currency': typeof LogbookCurrencyRoute;
  '/logbook/export': typeof LogbookExportRoute;
  '/logbook/print': typeof LogbookPrintRoute;
  '/logbook/totals': typeof LogbookTotalsRoute;
  '/aircraft': typeof AircraftIndexRoute;
  '/flights': typeof FlightsIndexRoute;
  '/logbook': typeof LogbookIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/aircraft': typeof AircraftRouteWithChildren;
  '/flights': typeof FlightsRouteWithChildren;
  '/logbook': typeof LogbookRouteWithChildren;
  '/settings': typeof SettingsRoute;
  '/aircraft/$aircraftId': typeof AircraftAircraftIdRoute;
  '/aircraft/new': typeof AircraftNewRoute;
  '/flights/$trackId': typeof FlightsTrackIdRoute;
  '/flights/fetch': typeof FlightsFetchRoute;
  '/logbook/checks': typeof LogbookChecksRoute;
  '/logbook/currency': typeof LogbookCurrencyRoute;
  '/logbook/export': typeof LogbookExportRoute;
  '/logbook/print': typeof LogbookPrintRoute;
  '/logbook/totals': typeof LogbookTotalsRoute;
  '/aircraft/': typeof AircraftIndexRoute;
  '/flights/': typeof FlightsIndexRoute;
  '/logbook/': typeof LogbookIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/about'
    | '/aircraft'
    | '/flights'
    | '/logbook'
    | '/settings'
    | '/aircraft/$aircraftId'
    | '/aircraft/new'
    | '/flights/$trackId'
    | '/flights/fetch'
    | '/logbook/checks'
    | '/logbook/currency'
    | '/logbook/export'
    | '/logbook/print'
    | '/logbook/totals'
    | '/aircraft/'
    | '/flights/'
    | '/logbook/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/about'
    | '/settings'
    | '/aircraft/$aircraftId'
    | '/aircraft/new'
    | '/flights/$trackId'
    | '/flights/fetch'
    | '/logbook/checks'
    | '/logbook/currency'
    | '/logbook/export'
    | '/logbook/print'
    | '/logbook/totals'
    | '/aircraft'
    | '/flights'
    | '/logbook';
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/aircraft'
    | '/flights'
    | '/logbook'
    | '/settings'
    | '/aircraft/$aircraftId'
    | '/aircraft/new'
    | '/flights/$trackId'
    | '/flights/fetch'
    | '/logbook/checks'
    | '/logbook/currency'
    | '/logbook/export'
    | '/logbook/print'
    | '/logbook/totals'
    | '/aircraft/'
    | '/flights/'
    | '/logbook/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AboutRoute: typeof AboutRoute;
  AircraftRoute: typeof AircraftRouteWithChildren;
  FlightsRoute: typeof FlightsRouteWithChildren;
  LogbookRoute: typeof LogbookRouteWithChildren;
  SettingsRoute: typeof SettingsRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/about': {
      id: '/about';
      path: '/about';
      fullPath: '/about';
      preLoaderRoute: typeof AboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/aircraft': {
      id: '/aircraft';
      path: '/aircraft';
      fullPath: '/aircraft';
      preLoaderRoute: typeof AircraftRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/flights': {
      id: '/flights';
      path: '/flights';
      fullPath: '/flights';
      preLoaderRoute: typeof FlightsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/logbook': {
      id: '/logbook';
      path: '/logbook';
      fullPath: '/logbook';
      preLoaderRoute: typeof LogbookRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/aircraft/': {
      id: '/aircraft/';
      path: '/';
      fullPath: '/aircraft/';
      preLoaderRoute: typeof AircraftIndexRouteImport;
      parentRoute: typeof AircraftRoute;
    };
    '/aircraft/$aircraftId': {
      id: '/aircraft/$aircraftId';
      path: '/$aircraftId';
      fullPath: '/aircraft/$aircraftId';
      preLoaderRoute: typeof AircraftAircraftIdRouteImport;
      parentRoute: typeof AircraftRoute;
    };
    '/aircraft/new': {
      id: '/aircraft/new';
      path: '/new';
      fullPath: '/aircraft/new';
      preLoaderRoute: typeof AircraftNewRouteImport;
      parentRoute: typeof AircraftRoute;
    };
    '/flights/': {
      id: '/flights/';
      path: '/';
      fullPath: '/flights/';
      preLoaderRoute: typeof FlightsIndexRouteImport;
      parentRoute: typeof FlightsRoute;
    };
    '/flights/$trackId': {
      id: '/flights/$trackId';
      path: '/$trackId';
      fullPath: '/flights/$trackId';
      preLoaderRoute: typeof FlightsTrackIdRouteImport;
      parentRoute: typeof FlightsRoute;
    };
    '/flights/fetch': {
      id: '/flights/fetch';
      path: '/fetch';
      fullPath: '/flights/fetch';
      preLoaderRoute: typeof FlightsFetchRouteImport;
      parentRoute: typeof FlightsRoute;
    };
    '/logbook/': {
      id: '/logbook/';
      path: '/';
      fullPath: '/logbook/';
      preLoaderRoute: typeof LogbookIndexRouteImport;
      parentRoute: typeof LogbookRoute;
    };
    '/logbook/checks': {
      id: '/logbook/checks';
      path: '/checks';
      fullPath: '/logbook/checks';
      preLoaderRoute: typeof LogbookChecksRouteImport;
      parentRoute: typeof LogbookRoute;
    };
    '/logbook/currency': {
      id: '/logbook/currency';
      path: '/currency';
      fullPath: '/logbook/currency';
      preLoaderRoute: typeof LogbookCurrencyRouteImport;
      parentRoute: typeof LogbookRoute;
    };
    '/logbook/export': {
      id: '/logbook/export';
      path: '/export';
      fullPath: '/logbook/export';
      preLoaderRoute: typeof LogbookExportRouteImport;
      parentRoute: typeof LogbookRoute;
    };
    '/logbook/print': {
      id: '/logbook/print';
      path: '/print';
      fullPath: '/logbook/print';
      preLoaderRoute: typeof LogbookPrintRouteImport;
      parentRoute: typeof LogbookRoute;
    };
    '/logbook/totals': {
      id: '/logbook/totals';
      path: '/totals';
      fullPath: '/logbook/totals';
      preLoaderRoute: typeof LogbookTotalsRouteImport;
      parentRoute: typeof LogbookRoute;
    };
  }
}

interface AircraftRouteChildren {
  AircraftAircraftIdRoute: typeof AircraftAircraftIdRoute;
  AircraftNewRoute: typeof AircraftNewRoute;
  AircraftIndexRoute: typeof AircraftIndexRoute;
}

const AircraftRouteChildren: AircraftRouteChildren = {
  AircraftAircraftIdRoute: AircraftAircraftIdRoute,
  AircraftNewRoute: AircraftNewRoute,
  AircraftIndexRoute: AircraftIndexRoute,
};

const AircraftRouteWithChildren = AircraftRoute._addFileChildren(
  AircraftRouteChildren,
);

interface FlightsRouteChildren {
  FlightsTrackIdRoute: typeof FlightsTrackIdRoute;
  FlightsFetchRoute: typeof FlightsFetchRoute;
  FlightsIndexRoute: typeof FlightsIndexRoute;
}

const FlightsRouteChildren: FlightsRouteChildren = {
  FlightsTrackIdRoute: FlightsTrackIdRoute,
  FlightsFetchRoute: FlightsFetchRoute,
  FlightsIndexRoute: FlightsIndexRoute,
};

const FlightsRouteWithChildren =
  FlightsRoute._addFileChildren(FlightsRouteChildren);

interface LogbookRouteChildren {
  LogbookChecksRoute: typeof LogbookChecksRoute;
  LogbookCurrencyRoute: typeof LogbookCurrencyRoute;
  LogbookExportRoute: typeof LogbookExportRoute;
  LogbookPrintRoute: typeof LogbookPrintRoute;
  LogbookTotalsRoute: typeof LogbookTotalsRoute;
  LogbookIndexRoute: typeof LogbookIndexRoute;
}

const LogbookRouteChildren: LogbookRouteChildren = {
  LogbookChecksRoute: LogbookChecksRoute,
  LogbookCurrencyRoute: LogbookCurrencyRoute,
  LogbookExportRoute: LogbookExportRoute,
  LogbookPrintRoute: LogbookPrintRoute,
  LogbookTotalsRoute: LogbookTotalsRoute,
  LogbookIndexRoute: LogbookIndexRoute,
};

const LogbookRouteWithChildren =
  LogbookRoute._addFileChildren(LogbookRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AircraftRoute: AircraftRouteWithChildren,
  FlightsRoute: FlightsRouteWithChildren,
  LogbookRoute: LogbookRouteWithChildren,
  SettingsRoute: SettingsRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
